import PhoneNumberInput from 'views/MFA/PhoneNumberInput/PhoneNumberInput';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import VerificationCode from 'views/MFA/CodeVerification/VerificationCode';
import useChangePhone from '../useChangePhone';
import { getUser } from 'services/user';

function ChangePhoneForm({
  setResolver = null,
  setUserCredentials = null,
  setVerificationId = null,
  resolver
}) {
  const [newVerificationId, setNewVerificationId] = useState('');
  const [newCredentials, setNewCredentials] = useState(null);

  const { phoneChanged, phoneNumber, setPhoneNumber, needsReauthentication } =
    useChangePhone();

  useEffect(() => {
    async function endFlow() {
      if (phoneChanged) {
        try {
          await getUser(newCredentials);
        } catch (error) {
          console.error(error);
        }
      }
    }

    endFlow();
  }, [phoneChanged]);

  useEffect(() => {
    if (needsReauthentication) {
      setResolver(null);
      setUserCredentials(null);
      setVerificationId('');
      setPhoneNumber('');
    }
  }, [needsReauthentication]);

  return (
    <>
      {newVerificationId === '' ? (
        <PhoneNumberInput
          resolver={resolver}
          setVerificationId={setNewVerificationId}
          setPhoneNumber={setPhoneNumber}
          newPhone
        />
      ) : (
        <VerificationCode
          resolver={resolver}
          verificationId={newVerificationId}
          phoneNumber={phoneNumber}
          setUserCredentials={setNewCredentials}
          reloadPortal={false}
          newPhone
          newPhoneUpdate
        />
      )}
    </>
  );
}

ChangePhoneForm.propTypes = {
  userCredentials: PropTypes.object,
  setResolver: PropTypes.func,
  setUserCredentials: PropTypes.func,
  setVerificationId: PropTypes.func,
  resolver: PropTypes.object
};

export default ChangePhoneForm;
